const marketplaces = {
    1: {
        id: 1,
        name: "Mercado Livre",
        icon: "/img/description/ml.svg",
        color: "#FEE600",
    },
    2: {
        id: 2,
        name: "Magalu",
        icon: "/img/description/magalu.svg",
        color: "#0EEBC5",
    },
    3: {
        id: 3,
        name: "Amazon",
        icon: "/img/description/amazon3.svg",
        color: "#F69B35",
    },
    4: {
        id: 4,
        name: "Olist",
        icon: "/img/description/olist.svg",
        color: "#178EFF",
    },
    5: {
        id: 5,
        name: "B2W",
        icon: "/img/description/b2w3.svg",
        color: "#0EEBC5",
    },
    6: {
        id: 6,
        name: "Shopee",
        icon: "/img/description/shopee2.svg",
        color: "#FF6E47",
    },
    7: {
        id: 7,
        name: "Outros",
        icon: "/img/description/outros4.svg",
        color: "#FFF",
    },
};

const productTypes = [
    { id: 0, name: "Relógio" },
    { id: 1, name: "Boné" },
    { id: 2, name: "Cinto" },
    { id: 3, name: "Colar" },
    { id: 4, name: "Brinco" },
    { id: 5, name: "Carteira" },
    { id: 6, name: "Óculos" },
    { id: 7, name: "Pulseira" },
    { id: 8, name: "Calçado" },
    { id: 9, name: "Anel" },
    { id: 10, name: "Lousa" },
];

const bene = ["original", "nota fiscal", "novo", "garantia", "presente"];

function generateTitle(product) {
    let benes = [...bene];
    let tags = product.tags.slice();
    // console.log(JSON.stringify(product));

    console.log(tags);

    let tag1 = tags.splice(Math.floor(Math.random() * tags.length), 1)[0];
    let tag2 = tags.splice(Math.floor(Math.random() * tags.length), 1)[0];
    let ben1 = benes.splice(Math.floor(Math.random() * benes.length), 1);
    let ben2 = benes.splice(Math.floor(Math.random() * benes.length), 1);

    console.log(tag1);

    return `${productTypes[product.type].name}${
        product.datasheet.genero ? ` ${product.datasheet.genero} ` : ""
    }${tag1 && tag2 ? ` ${tag1.text} ${tag2.text} ` : " "}${ben1} ${ben2}`;
}

export default generateTitle;
